import React, { useRef } from "react";
import { cls } from "@wss/cls";
import { FacetNavigation } from "./Filters";
import FilterList from "./FilterList";
import { GroupProps } from "./GroupProps";
import { CompatibleModel } from "~/common/Store/models/Category";

interface Props extends FacetNavigation {
  pageUrl: string;
  showSearchWithinFilter?: boolean;
  showCategoryFilter?: boolean;
  showOutletConditionFilter?: boolean;
  filterComponentOrder?: ((props: GroupProps) => JSX.Element)[];
  showPartsFilter?: boolean;
  prefetch?: boolean;
  compatibleModels?: CompatibleModel[];
  isFilterRemoved?: boolean;
}

const Sidebar = (props: Props) => {
  const filterContainer = useRef<HTMLDivElement>(null);
  const {
    pageUrl,
    showSearchWithinFilter = true,
    filterComponentOrder,
    showCategoryFilter = true,
    showOutletConditionFilter = false,
    showPartsFilter = true,
    prefetch,
    compatibleModels,
    isFilterRemoved,
  } = props;

  return (
    <nav
      id="sidebar"
      aria-label="filters"
      className="ag-filter aside hidden lt:block"
      data-component="toolbarMenu"
      data-testid="sidebar"
    >
      <div
        ref={filterContainer}
        className="ag-filter__container"
        data-component="filterContainer"
      >
        <ul
          className={cls(
            "filter-list bg-white border-l border-b border-r-0  border-t-0 border-gray-200 border-solid rounded-bl mt-0",
            {
              "pr-0 pt-0.5": showCategoryFilter,
            },
          )}
        >
          {props ? (
            <FilterList
              facetNavigation={props}
              filterContainer={filterContainer}
              showCategoryFilter={showCategoryFilter}
              showOutletConditionFilter={showOutletConditionFilter}
              showPartsFilter={showPartsFilter}
              pageUrl={pageUrl}
              showSearchWithinFilter={showSearchWithinFilter}
              filterComponentOrder={filterComponentOrder}
              prefetch={prefetch}
              compatibleModels={compatibleModels}
              isFilterRemoved={isFilterRemoved}
            />
          ) : null}
        </ul>
      </div>
    </nav>
  );
};

export default Sidebar;
